/**
 * Angular imports.
 */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

/**
 * Service imports.
 */
import { NewLanguageService } from './../../../dataservices/new-language/new-language.service';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { PostApiService } from '../../../dataservices/post-api.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { FunCollectionService } from '../../common-functions/fun-collection.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from 'src/app/constants/app.constants';

/**
 * Verification Success Modal Component
 */
@Component({
  selector: 'app-verification-success-modal',
  templateUrl: './verification-success-modal.component.html',
})
export class VerificationSuccessModalComponent implements OnDestroy, OnInit {
  @Input() data;
  @Input() callingfrom;
  isShownWebModal = false;
  displaySection = '';
  displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  private startTime = 0;


  /**
   * Necessary instances.
   */
  constructor(
    public mls: NewLanguageService,
    private dss: DataStorageService,
    private masterSer: MasterserviceService,
    private jwtSer: JwtDecodeService,
    private postApiSer: PostApiService,
    private analyticSdk: Analytics,
    public fcs: FunCollectionService) {

  }
  ngOnInit(): void {
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
      entity_code: 0,
      source: this.fcs.currentScreename,
      current_screen_name: SCREEN_NAME.VERIFICATION_STATUS,
      start_time: this.startTime = new Date().getTime()
    }
    this.analyticSdk.analyticService.ENTRY(entryData);
  }

  /**
   * go Back
   */
  goBack(): void {
    sessionStorage.removeItem('resub');
    this.dss.selected_suggAssList = [];
    const displayObj = {
      isShow: false,
      display_section: '',
      data: []
    };
    this.masterSer.showWebModal.next(displayObj);
  }

  /**
   * assign Association
   */
  assignAssociation(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.OTHER, 0, SCREEN_NAME.VERIFICATION_STATUS, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK,ACTION_ON.RESUBMIT_DOCUMENTS, null);
    const y = [];
    this.dss.selected_suggAssList.map(x => y.push(x.association_id));
    this.subscriptions.add(this.postApiSer.assignAssociation('association', '[' + y + ']', '', 1).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {

        if (data['status'] == 1) {
          if (data['code'] == 2000) {
            this.displayObj.isShow = true;
            this.displayObj.display_section = 'verificationSuccess';
            this.displayObj.data = data['data'];
            this.displayObj.errObj = [];
            this.masterSer.showWebModal.next(this.displayObj);
          }
        } else {
          this.fcs.errorHandeler(data);
          return;
        }
      });
    }));
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
      entity_code: 0,
      current_screen_name: SCREEN_NAME.VERIFICATION_STATUS,
      start_time: this.startTime,
      end_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.EXIT(exitData);
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
